// src/components/About.js
import React, { useRef, useEffect, useState } from 'react';
import ShapeDivider from './ShapeDivider';

const About = () => {
  const sectionRef = useRef(null);
  const headingRef = useRef(null);
  const contentRef = useRef(null);
  const missionRef = useRef(null);
  const commitmentRef = useRef(null);

  const [content, setContent] = useState({
    title: 'About Us',
    heading: 'Three Leaf Food & Beverages Trading L.L.C',
    body: `At Three Leaf, we specialize in end-to-end ingredient solutions for the food and beverage industry. Backed by years of experience and a strong network of trusted global partners, we deliver products that empower manufacturers, co-packers, and innovators to create delicious, nutritious, and market-ready products. We understand the unique dynamics of the GCC and Middle East — from regulatory compliance to cultural preferences — and design solutions that cater to both traditional tastes and modern demands. `,
    missionTitle: 'Our Mission',
    missionBody: "To bridge the gap between farms and factories, making nature's best fruits and ingredients accessible to food and beverage creators.",
    commitmentTitle: 'Our Commitment',
    commitmentBody: 'Sustainable sourcing, strong partnerships, and long-term value creation for our clients.'
  });

  const API_BASE = process.env.REACT_APP_API_BASE || (typeof window !== 'undefined' ? window.location.origin : '');

  useEffect(() => {
    // Fetch content from API
    fetch(API_BASE + '/backend/api.php/content?slug=about')
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(data => {
        if (data && data.item) {
          const jsonData = data.item.json || {};
          setContent({
            title: data.item.title || content.title,
            heading: jsonData.heading || content.heading,
            body: data.item.body || content.body,
            missionTitle: jsonData.missionTitle || content.missionTitle,
            missionBody: jsonData.missionBody || content.missionBody,
            commitmentTitle: jsonData.commitmentTitle || content.commitmentTitle,
            commitmentBody: jsonData.commitmentBody || content.commitmentBody
          });
        }
      })
      .catch(() => {});
  }, [API_BASE]);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
        }
      });
    }, { threshold: 0.1 });

    if (sectionRef.current) observer.observe(sectionRef.current);
    if (headingRef.current) observer.observe(headingRef.current);
    if (contentRef.current) observer.observe(contentRef.current);
    if (missionRef.current) observer.observe(missionRef.current);
    if (commitmentRef.current) observer.observe(commitmentRef.current);

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
      if (headingRef.current) observer.unobserve(headingRef.current);
      if (contentRef.current) observer.unobserve(contentRef.current);
      if (missionRef.current) observer.unobserve(missionRef.current);
      if (commitmentRef.current) observer.unobserve(commitmentRef.current);
    };
  }, []);

  return (
    <section id="about" className="section about-section" ref={sectionRef}>
      <div className="container">
        <h2 className="section-title animate-on-scroll slide-in-left" ref={headingRef}>{content.title}</h2>
        <div className="about-content">
          <div className="about-text animate-on-scroll fade-in delay-1" ref={contentRef}>
            <h3>{content.heading}</h3>
            <p>{content.body}</p>
          </div>
          <div className="mission-commitment-container">
            <div className="mission-text animate-on-scroll fade-in delay-2" ref={missionRef}>
              <h3>{content.missionTitle}</h3>
              <p>{content.missionBody}</p>
            </div>
            <div className="mission-text animate-on-scroll fade-in delay-3" ref={commitmentRef}>
              <h3>{content.commitmentTitle}</h3>
              <p>{content.commitmentBody}</p>
            </div>
          </div>
        </div>
      </div>
      <ShapeDivider />
    </section>
  );
};

export default About;